import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import Skill from '../../../../../../models/v2/skill';

// Base
import Badge from '../../../../base/badge';
import Button from '../../../../base/button';
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Loading from './platform_expertise/loading';

export default class PlatformExpertise extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    selectedPlatforms: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    if (isEmptyObject(persona) && (profile.platform_skill_ids || []).length > 0) {
      // For all personas
      Skill
        .where({ id_in: profile.platform_skill_ids })
        .all(false)
        .then((selectedPlatforms) => {
          this.setState({
            loading: false,
            selectedPlatforms,
          })
        })
    } else if (!isEmptyObject(persona) && (persona.platform_skill_ids || []).length > 0) {
      // For a specific persona
      Skill
        .where({ id_in: persona.platform_skill_ids })
        .all(false)
        .then((selectedPlatforms) => {
          this.setState({
            loading: false,
            selectedPlatforms,
          })
        })
    } else {
      this.setState({
        loading: false,
        selectedPlatforms: [],
      })
    }
  }

  render() {
    const { loading, selectedPlatforms } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Card
        border='none'
        className='min-height-80'
        noPadding
      >
        <Row className='margin-top-15 margin-bottom-10' nested>
          <Col s={12} className='med-font dark margin-bottom-10'>
            Platform Expertise
          </Col>
          <Col s={12}>
            {
              selectedPlatforms.map((skill) => (
                <Badge
                  key={skill.id}
                  text={skill.name}
                />
              ))
            }
            {
              selectedPlatforms.length === 0 &&
              <div className='gray-900'>None Selected</div>
            }
          </Col>
        </Row>
      </Card>
    )
  }
}